import dashboardBlueSvg from '../../assets/svg/Icons/48/dashboard-blue.svg';
import messagesBlueSvg from '../../assets/svg/Icons/48/messages-blue.svg';
import newsfeedBlueSvg from '../../assets/svg/Icons/48/newsfeed-blue.svg';
import dateBlueSvg from '../../assets/svg/Icons/48/date-blue.svg';
import taskBlueSvg from '../../assets/svg/Icons/48/task-blue.svg';

import slingTourModalUrl from './slingTourModal.html';

const ICONS_MAP = {
  dashboard: dashboardBlueSvg,
  messages: messagesBlueSvg,
  newsfeed: newsfeedBlueSvg,
  date: dateBlueSvg,
  task: taskBlueSvg,
};

export default {
  bindings: {
    icon: '@?',
    containerClass: '@?',
    headerClass: '@?',
    primaryButtonClass: '@?',
    bgPosition: '@',
    onDismiss: '&',
    onSecondary: '&',
    hideButton: '<?',
  },
  transclude: {
    header: 'slingTourHeader',
    description: '?slingTourDescription',
    button: '?slingTourButton',
    secondaryButton: '?slingTourSecondaryButton',
  },
  controller: SlingTourController,
  controllerAs: 'ctrl',
  templateUrl: slingTourModalUrl,
};

function SlingTourController($transclude) {
  'ngInject';

  const controller = this;

  controller.$onInit = $onInit;

  function $onInit() {
    controller.hasDescription = $transclude.isSlotFilled('description');
    controller.hasSecondaryButton = $transclude.isSlotFilled('secondaryButton');
    if (controller.icon) {
      controller.iconSrc = ICONS_MAP[controller.icon];
    }
  }
}
